declare const __BACKEND_URL__: string | undefined;
declare const __WS_PATH__: string | undefined;

// Injected by webpack DefinePlugin at build time; falls back to local dev default.
export const BACKEND_URL: string =
  typeof __BACKEND_URL__ !== "undefined" && __BACKEND_URL__
    ? __BACKEND_URL__
    : "http://localhost:3001";

/**
 * socket.io engine.io path. Default "/socket.io"; hinter einem Subpath-Reverse-Proxy
 * (z. B. nginx leitet /api/* ans Backend) auf "/api/socket.io" setzen, damit der
 * WS-Handshake durch dieselbe /api-Regel geht. Muss mit dem Server (WS_PATH) übereinstimmen.
 */
export const WS_PATH: string =
  typeof __WS_PATH__ !== "undefined" && __WS_PATH__ ? __WS_PATH__ : "/socket.io";

/**
 * Origin (Schema+Host) des Backends — für die socket.io-Verbindung. Der Namespace ergibt
 * sich aus der Origin + "/<namespace>" (NICHT aus einem evtl. /api-Pfad in BACKEND_URL),
 * sonst meldet der Server „Invalid namespace".
 */
export const SOCKET_ORIGIN: string = (() => {
  try {
    return new URL(BACKEND_URL).origin;
  } catch {
    return BACKEND_URL.replace(/\/+$/, "");
  }
})();
